import { render, staticRenderFns } from "./AssignReviewMembersPopup.vue?vue&type=template&id=69235476&"
import script from "./AssignReviewMembersPopup.vue?vue&type=script&lang=js&"
export * from "./AssignReviewMembersPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports